import { Fragment } from 'react'

import BlogCategoryLink from '@/components/BlogCategoryLink'
import type { BlogCategory } from '@/utils/types'

type Props = {
  categories: BlogCategory[]
}

export default function BlogCategoryLinks({ categories }: Props) {
  return categories.map((category, index) => (
    <Fragment key={category}>
      {index > 0 && ', '}
      <BlogCategoryLink category={category} />
    </Fragment>
  ))
}
